<div class="container">
  <div class="row">
    <!-- Left Sidebar -->
    <div class="col-6 col-sm-6 col-md-3 col-xl-3 order-md-1 order-2 sidebar-down">
      <div class="mb-0" *ngFor="let functTypeKey of getFunctTypeKeys().slice(0,4)">
        <div class="card" (click)="openTablePopup(functTypeKey)">
          <div class="card-body card-body-inline">
            <p class="circle-tile-number hover-element">{{functAllCount[functTypeKey]}} </p>
            <img src="assets/img/{{ functTypeKey }}.png" class="card-img-top" alt="Logo" />
          </div>
          <div class="card-footer bg-transparent">
            <!-- Mobile view, visible only on screens smaller than md breakpoint -->
            <h5 class="card-title text-center split-title d-block d-md-none">
              <ng-container *ngIf="functTypeKey.split(' ').length > 1">
                <span>{{ functTypeKey.split(' ')[0] }}</span><br>
                <span>{{ functTypeKey.split(' ')[1] }}</span>
              </ng-container>
              <ng-container *ngIf="functTypeKey.split(' ').length === 1">
                {{ functTypeKey }}
              </ng-container>
            </h5>

            <!-- Desktop view, visible only on screens md and larger -->
            <h5 class="card-title text-center d-none d-md-block">
              {{ functTypeKey }}
            </h5>
          </div>

        </div>
      </div>

      <div class="mb-0">
        <div class="card">
          <div class="card-body card-body-inline">
            <p class="circle-tile-number hover-element">0</p>
            <img src="assets/img/additional.png" class="card-img-top" style="width: 65px;" alt="Logo" />
          </div>
          <div class="card-footer bg-transparent">
            <h5 class="card-title text-center">Additional Slot</h5>
          </div>
        </div>
      </div>

    </div>

    <!-- Center Content -->
    <div class="col-md-6 col-xl-6  order-md-2 order-1">

      <div class="headcount-container">
        <div class="circle-headcount">
          <div class="img-in-out">
            <div class="headcount-img">
              <div class="circle-tile-number headcount-data hover-element" (click)="openTablePopup(functTypeKey)">
                {{ totalHeadcount }}
                <!-- 8000 -->
              </div>
              <img class="head-img" src="assets/img/Picture5.png" />
            </div>
            <div class="total-headcount-text">
              <div> <b>Total</b> HEADCOUNT</div>
              <div style="text-align: center;"><p class="main-text">({{ this.areaTypeName }})</p></div>
            </div>
          </div>
        </div>

        <div class="datetime datetime-container">
          <div class="date-text">{{ currentDate | date: 'EEEE d MMMM' }}</div>
          <div class="time-text">{{ currentTime }}</div>
          <img class="client-logo" src="assets/img/dnvlogo.png" />

    
        </div>

      </div>


      <!-- Additional center content here -->

      <div class="container card cardtable d-none d-md-block">
        <div class="row">
          <div class="headpart">
            <p class="headtext">Last 5 People</p>

            <div class="image inoutimg">
              <img src="assets/img/inout.png" alt="" srcset="" class="img-fluid" />
            </div>
          </div>
          <div class="container teb_de">
            <div class="row">
              <!-- First Half of the Table -->
              <div class="col-xl-6 col-md-6 col-sm-12">
                <table class="table table-striped">
                  <thead class="custom-header">
                    <tr>
                      <th class="nameheader">Name</th>
                      <!-- <th class="row-header"> -->
                      <th>In Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="inData.length > 0; else placeholderRows">
                      <tr *ngFor="let person of inData">
                        <td class="td-height">{{ person.Name }}</td>
                        <td class="td-height">{{ person.Time | date:'HH:mm':'Asia/Kolkata'}}</td>
                      </tr>
                    </ng-container>
                    <ng-template #placeholderRows>
                      <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
                        <td class="td-height">&nbsp;</td>
                        <td class="td-height">&nbsp;</td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>

              <div class="image inoutimg headtext col-md-12 d-none d-md-none">
                <img src="assets/img/inout.png" alt="" srcset="" class="img-fluid" />
              </div>

              <!-- Second Half of the Table -->
              <div class="col-xl-6 col-md-6 col-sm-12">
                <table class="table table-striped">
                  <thead class="custom-header">
                    <tr>
                      <th class="nameheader">Name</th>
                      <th>Out Time </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="outData.length > 0; else placeholderRows">
                      <tr *ngFor="let person of outData">
                        <td class="td-height">{{ person.Name }}</td>
                        <td class="td-height">{{ person.Time | date:'HH:mm':'Asia/Kolkata'}}</td>
                      </tr>
                    </ng-container>
                    <ng-template #placeholderRows>
                      <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
                        <td class="td-height">&nbsp;</td>
                        <td class="td-height">&nbsp;</td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-container d-none d-md-block">
        <div class="row">
            <div class="footerflx">
              <div class="footer-content">
                <img src="assets/img/lighthouse.png" alt="" class="lighthouse-img" />
                <p class="footer-text">Powered By</p>
                <img src="assets/img/Picture10.png" alt="" class="dnv-img" />
              </div>
            </div>
        </div>
      </div>
    </div>

    <!-- Right Sidebar -->
    <div class="col-6 col-sm-6 col-md-3 col-xl-3 order-md-3 order-3 sidebar-down">
      <div class="mb-0" *ngFor="let functTypeKey of getFunctTypeKeys().slice(4)">
        <div class="card" (click)="openTablePopup(functTypeKey)">
          <div class="card-body card-body-inline">
            <img src="assets/img/{{ functTypeKey }}.png" class="card-img-top" alt="Logo" />
            <p class="circle-tile-number hover-element">{{functAllCount[functTypeKey]}}</p>
          </div>
          <div class="card-footer bg-transparent">
            <!-- Mobile view, visible only on screens smaller than md breakpoint -->
            <h5 class="card-title text-center split-title d-block d-md-none">
              <ng-container *ngIf="functTypeKey.split(' ').length > 1">
                <span>{{ functTypeKey.split(' ')[0] }}</span><br>
                <span>{{ functTypeKey.split(' ')[1] }}</span>
              </ng-container>
              <ng-container *ngIf="functTypeKey.split(' ').length === 1">
                {{ functTypeKey }}
              </ng-container>
            </h5>

            <!-- Desktop view, visible only on screens md and larger -->
            <h5 class="card-title text-center d-none d-md-block">
              {{ functTypeKey }}
            </h5>
          </div>
        </div>
      </div>

      <div class="mb-0">
        <div class="card">
          <div class="card-body card-body-inline">
            <img src="assets/img/additional.png" class="card-img-top" style="width: 65px;" alt="Logo" />
            <p class="circle-tile-number hover-element">0</p>
          </div>
          <div class="card-footer bg-transparent">
            <h5 class="card-title text-center">Additional Slot</h5>
          </div>
        </div>
      </div>

    </div>

    <div class="container card cardtable  col-md-6 col-xl-6 d-md-none order-md-2 order-3">
      <div class="row">
        <div class="headpart">
          <div class="headtext">
            <h3 class="headtext">Last 5 People</h3>
          </div>
          <div class="image inoutimg">
            <img src="assets/img/inout.png" alt="" srcset="" class="img-fluid" />
          </div>
        </div>
        <div class="container teb_de">
          <div class="row">
            <!-- First Half of the Table -->
            <div class="col-xl-6 col-md-6 col-sm-12">
              <table class="table table-striped">
                <thead class="custom-header">
                  <tr>
                    <th class="column-width" style="width: 280px;">Name</th>
                    <th id="tablet" class="row-header">In Time</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="inData.length > 0; else placeholderRows">
                    <tr *ngFor="let person of inData">
                      <td>{{ person.Name }}</td>
                      <td>{{ person.Time | date:'HH:mm':'Asia/Kolkata' }}</td>
                    </tr>
                  </ng-container>
                  <ng-template #placeholderRows>
                    <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>

            <div class="image inoutimg headtext col-md-12 d-none d-md-none">
              <img src="assets/img/inout.png" alt="" srcset="" class="img-fluid" />
            </div>

            <!-- Second Half of the Table -->
            <div class="col-xl-6 col-md-6 col-sm-12">
              <table class="table table-striped">
                <thead class="custom-header">
                  <tr>
                    <th class="column-width" style="width: 280px;">Name</th>
                    <th>Out Time</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="outData.length > 0; else placeholderRows">
                    <tr *ngFor="let person of outData">
                      <td>{{ person.Name }}</td>
                      <td>{{ person.Time | date:'HH:mm':'Asia/Kolkata' }}</td>
                    </tr>
                  </ng-container>
                  <ng-template #placeholderRows>
                    <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    

  </div>
  <div class="container">
    <div class="row">
      <!-- <footer class="col-sm-12 d-md-none mt-0 p-2 text-center footerflx"> -->
      <!-- <img src="assets/img/lighthouse.png" alt="" class="lighthouse-img" />
        Powered by
        <img src="assets/img/Picture10.png" alt="" style="mix-blend-mode: multiply" /> -->

      <div class="row">
        <footer class="col-sm-12 d-md-none mt-0 p-2 text-center footerflx">

          <div class="footer-content">
            <img src="assets/img/lighthouse.png" alt="" class="lighthouse-img" />
            <p class="footer-text">Powered By</p>
            <img src="assets/img/Picture10.png" alt="" class="dnv-img" />
          </div>

        </footer>

      </div>


      <!-- </footer> -->
    </div>
  </div>
</div>